import type { ThemeOptions } from '@mui/material';

import { black, white } from '~/styles/colors';

const FormControlTheme: ThemeOptions['components'] = {
  MuiFormControl: {
    variants: [
      {
        props: { variant: 'outlined' },
        style: {
          borderColor: black[200],
          backgroundColor: white,
        },
      },
    ],
  },
};

export default FormControlTheme;
